export const INTAKE_TASK_IDS = {
  INTRO: "intake_intro",
  DEATH_CERT: "intake_death_cert",
  CONFIRM_DETAILS: "intake_confirm_details",
  AUTHORITY: "intake_authority",
  INVITES: "intake_invites",
  LEGAL_AUTHORITY: "legal_authority",
} as const;

export type IntakeTaskId = (typeof INTAKE_TASK_IDS)[keyof typeof INTAKE_TASK_IDS];

export const TASK_IDS = {
  WILL: "will",
  TRUST: "trust",
  LOT: "lot",
  ESTATE_SIZE: "estate_size",
  NOTIFY_CREDIT_BUREAUS: "notify_credit_bureaus",
  PROBATE_CHECK_WILL: "probate_check_will",
  PROBATE_EXECUTOR_WITNESSES: "probate_executor_witnesses",
  PROBATE_FAMILY_TRIAGE: "probate_family_triage",
  PROBATE_FAMILY_SIGNOFFS: "probate_family_signoffs",
} as const;

export type EstateTaskId = (typeof TASK_IDS)[keyof typeof TASK_IDS];

export const AUTHORITY_TASK_IDS = [TASK_IDS.LOT, TASK_IDS.TRUST] as const;

export type AuthorityTaskId = (typeof AUTHORITY_TASK_IDS)[number];

export const SETTLE_TASK_IDS = {
  GET_EIN: "settle_get_ein",
  OPEN_BANK: "settle_open_bank",
  CONNECT_BANK: "settle_connect_bank",
} as const;

export type SettleTaskId = (typeof SETTLE_TASK_IDS)[keyof typeof SETTLE_TASK_IDS];

export const ADMIN_TASK_IDS = {
  WILL_SEARCH: "admin_will_search",
  FAMILY_TRIAGE: "admin_family_triage",
  CONFIRM_ADMIN: "admin_confirm_admin",
  FAMILY_SIGNOFFS: "admin_family_signoffs",
  FORMS_PACKET: "admin_forms_packet",
} as const;

export type AdminTaskId = (typeof ADMIN_TASK_IDS)[keyof typeof ADMIN_TASK_IDS];
